import { render, staticRenderFns } from "./DefaultLiveEventDetail.vue?vue&type=template&id=6606523f"
import script from "./DefaultLiveEventDetail.vue?vue&type=script&lang=js"
export * from "./DefaultLiveEventDetail.vue?vue&type=script&lang=js"
import style0 from "./DefaultLiveEventDetail.vue?vue&type=style&index=0&id=6606523f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports